import React from 'react';
export const DiscoverySection = () => {
  return <section className="mb-10" data-id="element-41">
      <h2 className="text-4xl font-bold text-gray-800 mb-4" data-id="element-42">
        The Discovery That Shocked Me
      </h2>
      <p className="text-xl mb-4 italic" data-id="element-43">
        "While researching alternatives for Bailey, I stumbled across studies
        that completely changed my understanding of canine anxiety.
      </p>
      <div className="w-full h-[200px] bg-gray-200 mb-6 overflow-hidden" data-id="element-44">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kC8VcEqjB5B2E7dfit7AyB/image-93416-800.jpg" alt="Anxious dog looking out window" className="w-full h-full object-cover" data-id="element-45" />
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-46">
        The Temple Grandin Connection:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-47">
        Dr. Temple Grandin's groundbreaking work with livestock showed that
        gentle, consistent pressure could calm animals naturally - without
        drugs, without side effects.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-48">
        But here's what shocked me: This same principle works even better on
        dogs.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-49">
        The Science Behind 'Pressure Therapy':
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-50">
        <li className="mb-1" data-id="element-51">
          Gentle pressure triggers the release of natural endorphins
        </li>
        <li className="mb-1" data-id="element-52">It mimics the calming touch of a mother dog</li>
        <li className="mb-1" data-id="element-53">
          Works immediately (no 6-week 'adjustment period' like medications)
        </li>
        <li className="mb-1" data-id="element-54">
          No side effects because it works WITH the dog's natural systems
        </li>
      </ul>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-55">
        Why This Isn't Just 'Another Vest':
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-56">
        I'd seen anxiety vests before. Most of my clients had tried
        ThunderShirts with mixed results. But this was different.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-57">
        The key isn't just pressure - it's the RIGHT KIND of pressure, applied
        in the RIGHT WAY.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-58">
        Bailey's Transformation:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-59">
        I decided to try this approach with Bailey. Within MINUTES of putting on
        what I now call 'therapeutic compression,' something incredible
        happened:
      </p>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-60">
        <li className="mb-1" data-id="element-61">His body relaxed visibly</li>
        <li className="mb-1" data-id="element-62">His breathing slowed and deepened</li>
        <li className="mb-1" data-id="element-63">
          During the next thunderstorm, he actually fell asleep
        </li>
        <li className="mb-1 font-bold" data-id="element-64">
          Most importantly: he was still Bailey - playful, intelligent, full of
          life
        </li>
      </ul>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-65">
        The Clinical Results:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-66">
        Over the next year, I started recommending this approach to select
        clients instead of medication. The results were remarkable:
      </p>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-67">
        <li className="mb-1" data-id="element-68">89% of dogs showed immediate calming response</li>
        <li className="mb-1" data-id="element-69">Zero side effects reported</li>
        <li className="mb-1" data-id="element-70">Dogs maintained their full personalities</li>
        <li className="mb-1" data-id="element-71">
          Many owners were able to discontinue medications entirely (under
          supervision)
        </li>
      </ul>
      <p className="text-xl mb-4 italic" data-id="element-72">What I Tell Pet Owners Now:</p>
      <p className="text-xl mb-4 italic font-bold" data-id="element-73">
        'Before we consider medication, let's try working WITH your dog's
        natural calming systems instead of against them.'"
      </p>
    </section>;
};